import { put, takeLatest } from 'redux-saga/effects';
import downloadImageService from '../services/downloadImageService';
import { GET_IMAGE, getImageSuccess, getImageFailure } from '../reducers/downloadImageReducer';

function* getImage(action) {
  try {
    const image = yield downloadImageService(action.uri);
    yield put(getImageSuccess(image));
  } catch (error) {
    yield put(getImageFailure(error));
  }
}

export default function* downloadImageSaga() {
  yield takeLatest(GET_IMAGE, getImage)
}
